export default __webpack_public_path__ + "static/media/amaze-13.ab1ec831.jpg";